import { type Actions, ActionType } from './building-indicators.actions';
import { buildingIndicatorsAdapter, initialState, type State } from './building-indicators.state';

export function buildingIndicatorsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }

        case ActionType.FETCH_BUILDING_INDICATORS: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_BUILDING_INDICATORS_SUCCEEDED: {
            return buildingIndicatorsAdapter.setAll(action.payload.buildingIndicators, { ...state, isLoaded: true, isPending: false });
        }

        case ActionType.FETCH_BUILDING_INDICATORS_FAILED: {
            return { ...state, isLoaded: false, isPending: false };
        }

        default:
            return state;
    }
}
